var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FB7700","d":"M0 10.6h6.09L8.04 0H1.95L0 10.6Zm7.96 0h6.09L16 0H9.91L7.96 10.6Z"}));
}

Quote.defaultProps = {"className":"quote-svg","fill":"none","viewBox":"0 0 16 11","width":"16","height":"11"};

module.exports = Quote;

Quote.default = Quote;
